import React from "react";
import { useNavigate } from "react-router-dom";
import { Rocket } from "lucide-react";
import Reveal from "./Reveal";
import { useAuth } from "@/contexts/AuthContext";
import { resolveCtaTarget } from "@/lib/ctaTarget";

export const FinalCTA = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const ctaTarget = resolveCtaTarget(user);
    return (
        <section
            data-testid="final-cta"
            className="relative py-32 md:py-40 overflow-hidden"
        >
            {/* Intensified orbs */}
            <div className="absolute inset-0 pointer-events-none" aria-hidden>
                <div className="orb orb-primary" style={{ width: 720, height: 720, top: -180, left: "20%", opacity: 0.16 }} />
                <div className="orb orb-success" style={{ width: 640, height: 640, bottom: -200, right: "10%", opacity: 0.12 }} />
                <div className="absolute inset-0" style={{ background: "linear-gradient(135deg, rgba(109,94,248,0.05), rgba(45,212,191,0.04))" }} />
            </div>

            <div className="container-mx relative z-10 text-center">
                <Reveal>
                    <div className="tag tag-primary inline-flex">// готові почати?</div>
                </Reveal>

                <Reveal delay={0.1}>
                    <h2 className="mt-7 font-display font-extrabold text-text-primary leading-[0.95] mx-auto" style={{ fontSize: "clamp(48px, 8vw, 96px)", letterSpacing: "-0.035em", maxWidth: 920 }}>
                        20 хвилин до{" "}
                        <span
                            style={{
                                background: "linear-gradient(135deg, #6D5EF8, #2DD4BF)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                                backgroundClip: "text",
                            }}
                        >
                            першої кампанії
                        </span>
                    </h2>
                </Reveal>

                <Reveal delay={0.2}>
                    <p className="mt-6 text-lg text-secondary-c max-w-[560px] mx-auto">
                        Поки конкуренти платять агентствам — ви запускаєте самі.
                    </p>
                </Reveal>

                <Reveal delay={0.3}>
                    <div className="mt-10 flex justify-center">
                        <button
                            onClick={() => navigate(ctaTarget)}
                            className="btn-primary pulse-glow text-base px-8 py-4"
                            data-testid="final-cta-btn"
                        >
                            <Rocket size={18} /> {user ? "Перейти в кабінет →" : "Активувати AI — безкоштовно 7 днів"}
                        </button>
                    </div>
                </Reveal>

                <Reveal delay={0.4}>
                    <p className="mt-5 text-xs font-mono text-faint-c">
                        Скасуйте у 1 клік · Без контракту
                    </p>
                </Reveal>
            </div>
        </section>
    );
};

export default FinalCTA;
